module.exports = __webpack_public_path__ + "img/互助站.baf8b742.png";